import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useResponsive } from '@/hooks/useResponsive';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import { Footer } from '@/v2/components/Footer';
import GlassGridBackground from '@/v2/components/GlassGridBackground';
import { NavBar } from '@/v2/components/NavBar';

import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import styles from './index.module.less';

/**
 * Pricing 页面组件
 * 展示价格计划和常见问题
 */
export const Pricing: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  useScrollToTop();

  // 页面入场淡入动画（与 Download 页面保持一致）
  useEffect(() => {
    const pageElement = document.querySelector(`.${styles.pricingPage}`);
    if (pageElement) {
      const timer = setTimeout(() => {
        pageElement.classList.remove(styles.loading);
        pageElement.classList.add(styles.loaded);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className={`${styles.pricingPage} ${styles.loading} ${isMobile ? styles.mobileLayout : ''}`}>
      {/* 导航栏 */}
      <NavBar />

      {/* 主内容区域 */}
      <div className={styles.mainContent}>
        {/* 毛玻璃格子背景 */}
        <GlassGridBackground />
        
        {/* 价格计划区域 */}
        <PricingSection />
      </div>

      {/* FAQ 部分 */}
      <FAQSection />

      {/* 页脚 */}
      <Footer />
    </div>
  );
};

export default Pricing;
